module.exports = __webpack_public_path__ + "static/media/Museum_of_the_new_South_Charlotte_NC_Faux_painted_marble_finished_paint_2.e9b44181.webp";